import React from 'react';
import store from 'redux/store';
import { InjectIntlContext } from 'hooks/useIntl';
import { connect as connectSocket } from 'redux/ducks/socket';
import { Provider } from 'react-redux';
import ConnectedIntlProvider from 'helpers/ConnectedIntlProvider';
import Layout from './Layout';
import { IsMobileProvider } from 'hooks/useIsMobile';
import { HelmetProvider } from 'react-helmet-async';

store.dispatch<any>(connectSocket());

export default class App extends React.Component {
  render() {
    return (
      <Provider store={store as any}>
        <HelmetProvider>
          <ConnectedIntlProvider>
            <InjectIntlContext>
              <IsMobileProvider>
                <Layout />
              </IsMobileProvider>
            </InjectIntlContext>
          </ConnectedIntlProvider>
        </HelmetProvider>
      </Provider>
    );
  }
}
